import * as actionTypes from '../constants/addressConstants';

// export const address = ( state = { allAddresses: [] },action) => {

//     switch (action.type){
//         case actionTypes.ALL_ADDRESSES_REQUESTS:
//             return {
//                 loading: true,
//                 allAddresses: []
//             };
//             case actionTypes.ALL_ADDRESSES_REQUESTS_SUCCESS:
//                 return {
//                     loading: false,
//                     allAddresses: action.payload.allAddresses,
//                 };
//             case actionTypes.ALL_ADDRESSES_REQUESTS_FAIL:
//                  return {
//                     loading: false,
//                      error: action.payload
//                 };
//                  default:
//                  return state;
//     }
// };

export const addressReducer = (state = { address: [] }, action) => {

    switch (action.type) {
        case actionTypes.USER_ADDRESS_REQUEST:
            return {
                loading: true,
            };
        case actionTypes.USER_ADDRESS_SUCCESS:
            return {
                loading: false,
                address: action.payload.address
            };
        case actionTypes.USER_ADDRESS_FAIL:
            return {
                loading: false,
                user: null,
                error: action.payload
            };
        case actionTypes.ADD_ADDRESS_REQUEST:
            return {
                loading: true,
            };
        case actionTypes.ADD_ADDRESS_SUCCESS:
            return {
                loading: false,
                address: action.payload.address
            };
        case actionTypes.ADD_ADDRESS_FAIL:
            return {
                loading: false,
                user: null,
                error: action.payload
            };
        default:
            return state;
    }
};